import { render, staticRenderFns } from "./PostingHistoryTable.vue?vue&type=template&id=1d14076e&scoped=true&"
import script from "./PostingHistoryTable.vue?vue&type=script&lang=js&"
export * from "./PostingHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./PostingHistoryTable.vue?vue&type=style&index=0&id=1d14076e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d14076e",
  null
  
)

export default component.exports